import React, { SyntheticEvent, useRef, useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import { useNavigate, useParams } from 'react-router-dom';
import { ConfirmationPopup, ICONS, Icon, Loader, SuccessModal, Tooltip, useTheme } from '@ohif/ui';
import { useDropzone } from 'react-dropzone';
import { formatDate } from '@custom/Utils/utils';
import getIcon from '../../../ui/src/components/Icon/getIcon';
import AssignPathologistModal from '@custom/Patients/PatientDetail/AssignPathologistModal';
import uploadImageMicroscopy from '@custom/rtk-apis/microscopy/index';
import { resetUploadImageState } from '@custom/store/slices/Microscopy/index'
import uploadVideoMicroscopy from '@custom/rtk-apis/microscopy/uploadVideo';
import { resetUploadVideoState } from '@custom/store/slices/Microscopy/uploadVideoSlice';
import fetchPathologistUser from '@custom/rtk-apis/pathologistuser/getPathologistUser';
import getPatientMicroscopyData from '@custom/rtk-apis/microscopy/getPatientMicroscopicLink';
import { HospitalDetails, ImportScanType } from '@custom/Utils/constants/interfaces'
import { _roleType } from '@custom/Utils/constants/appConstants';
import addStudyResearch from '@custom/rtk-apis/studyResearch/addStudyResearch';
import { servicesManager } from '../../../app/src/App';
import { closeModal } from '@custom/store/slices/StudyResearch/addStudyResearchSlice'
import assignToSuperadmin from '@custom/rtk-apis/microscopy/assignToSuperadmin';
import { getCurrentReport } from '@custom/Apis/apis';
import assignPathologistApi from '@custom/rtk-apis/pathologistuser/assignPathologist';
import hospitalDetailApi from '@custom/rtk-apis/hospital/hospitalDetails';
import { clearAssignState } from '@custom/store/slices/Microscopy/assignToSuperadminSlice';
import { extraStorageIconSvg } from '../../../ui/assets/svgIcons/icon';
import switchPathologyStudyStorage from '@custom/rtk-apis/microscopy/switchPathologyStudyStorage';
const defaultHospitalDetails: HospitalDetails = {
  _id: '',
  hospitalName: '',
  hospitalEmailId: '',
  address: '',
  zipCode: '',
  country: '',
  state: '',
  city: '',
  hfrId: '',
  website: '',
  contactNumberCountryCode: '',
  hospitalData: '',
  contactNumber: '',
  whatsappCountryCode: '',
  whatsapp: '',
  emergencyContactNumberCountryCode: '',
  emergencyContactNumber: '',
  noOfHealthCareProfessional: '',
  specialitites: '',
  sameAsContact: '',
  signature: '',
  telepathology: false,
  teleradiology: false,
  user: {
    _id: '',
    name: '',
    email: '',
    contactNumber: '',
    countryCode: '',
    whatsapp: '',
    whatsappCountryCode: '',
    sameAsContact: '',
    superAdminSameAsContact: '',
  },

};

const ImportScan = (ImportScanProps: ImportScanType) => {
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { uhid } = useParams<{ uhid: string }>();
  const dropdownRef = useRef([]);
  const [prescriptionListData, setPrescriptionList] = useState([])
  const [openIndex, setOpenIndex] = useState(null);
  const [modal, setModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState({
    title: "",
    message: "",
    type: "",
    isOpen: false
  })
  const [hospitalDetails, setHospitalDetails] = useState<HospitalDetails>(defaultHospitalDetails)
  const [isModaPathologist, setIsModalPathologist] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModal] = useState(false);
  const [SuccessMessage, setSuccessMessage] = useState("");
  const [preview, setPreview] = useState('');
  const [prescription, setPrescription] = useState(null);
  const [loader, setLoader] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState(null);
  const [selectedWSI, setSelectedWSI] = useState('');
  const [pathologiestData, setPathologistsData] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showActionDropdown, setShowActionDropdown] = useState<{ [key: string]: boolean }>({});
  const [patientMicroscopyDetailResponse, setPatientMicroscopyDetailResponse] = useState({
    result: []
  });
  const [selectedStudies, setSelectedStudies] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);

  const currentPathologistId = sessionStorage.getItem('userId') || localStorage.getItem('userId');

  const uploadImageMicroscopyResponse = useSelector((state: RootState) => state?.uploadImageMicroscopyResponse);
  const uploadVideoMicroscopyResponse = useSelector((state: RootState) => state?.uploadVideoMicroscopyResponse);
  const patientDetails = useSelector((state: RootState) => state?.patientdetailResponce);
  const addResearchResponse = useSelector((state: RootState) => state?.addStudyReserach);
  const assignedToSuperAdminResponse = useSelector((state: RootState) => state.assignToSuperadminResponse)
  const hospitalDetailsData = useSelector((state: RootState) => state?.hospitalDetailsResponse);
  const role = sessionStorage.getItem('role') || localStorage.getItem('role');
  const { uiNotificationService } = servicesManager.services;

  const serviceTelepathology = hospitalDetails?.telepathology || false;
  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result as string);
      };
      reader.readAsDataURL(file); // Convert the file to Base64
    }
    setPrescription(file);
  }, []);


  const handleUploadImage = async () => {
    if (!prescription) {
      console.error('No file selected for upload.');
      return;
    }

    setLoader(true);
    setUploadProgress(0);

    const formData = new FormData();
    formData.append('uhid', uhid);
    formData.append('file', prescription);

    const isVideo = prescription.type.startsWith('video/');

    // Start the API call immediately
    const uploadPromise = isVideo
      ? dispatch(uploadVideoMicroscopy(formData))
      : dispatch(uploadImageMicroscopy(formData));

    // Start progress bar animation
    let currentProgress = 0;
    const maxFakeProgress = 98;
    const progressInterval = setInterval(() => {
      setUploadProgress(prev => {
        if (prev < maxFakeProgress) {
          const increment = Math.random() * 5 + 2; // Random increment between 2-7
          const newProgress = Math.min(Math.round(prev + increment), maxFakeProgress);
          currentProgress = newProgress;
          return newProgress;
        }
        return prev;
      });
    }, 50); // Update every 500ms

    try {
      // Wait for API response
      await uploadPromise;

      // Clear interval and set to 100% on success
      clearInterval(progressInterval);
      setUploadProgress(100);

      // Small delay to show 100% before success modal
      setTimeout(() => {
        setLoader(false);
      }, 500);

    } catch (error) {
      // On error, clear interval and reset to 0
      clearInterval(progressInterval);
      setUploadProgress(0);
      setLoader(false);

      uiNotificationService.show({
        title: 'Error',
        message: 'Upload failed. Please try again.',
        type: 'error',
        duration: 3000,
      });
    }
  };
  const handlePathologist = (e, selectedWSIid) => {
    e.stopPropagation();
    setSelectedWSI(selectedWSIid)
    setIsModalPathologist(true);
    //setPatientName(row[0].content.props.children);
  };

  const handleAssignSuccess = (assignedPathologist) => {
    setIsModalPathologist(false);
    setIsSuccessModal(true)
    setSuccessMessage('Pathologist assigned successfully.')
    // Update the state to reflect the newly assigned pathologist
    const updatedPatientMicroscopyDetailResponse = patientMicroscopyDetailResponse.result.map(item => {
      if (item.id === selectedWSI) {
        return {
          ...item,
          assignedToPathologist: assignedPathologist._id,
        };
      }
      return item;
    });

    // Update the state with the new data
    setPatientMicroscopyDetailResponse({
      ...patientMicroscopyDetailResponse,
      result: updatedPatientMicroscopyDetailResponse,
    });

    // Update the pathologists data to include the newly assigned pathologist
    setPathologistsData([...pathologiestData, assignedPathologist]);
  };


// ✅ Combine common upload handling logic
useEffect(() => {
  const handleResponse = (response, resetAction) => {
    if (!response.loading) {
      if (response.status === 'SUCCESS') {
        if (uploadProgress >= 100) {
          setSuccessMsg(response.msg);
          setModal(true);
          setPrescription(null);
          setPreview('');
          setLoader(false);
          dispatch(resetAction());
        }
      } else if (response.status === 'ERROR') {
        uiNotificationService.show({
          title: 'Error',
          message: response.msg || 'Something went wrong while uploading.',
          type: 'error',
          duration: 3000,
        });
        setLoader(false);
        dispatch(resetAction());
      }
    }
  };

  handleResponse(uploadVideoMicroscopyResponse, resetUploadVideoState);
  handleResponse(uploadImageMicroscopyResponse, resetUploadImageState);

}, [
  uploadVideoMicroscopyResponse.status,
  uploadVideoMicroscopyResponse.loading,
  uploadImageMicroscopyResponse.status,
  uploadImageMicroscopyResponse.loading,
  uploadProgress
]);

// ✅ Fetch only once when any upload finishes successfully
useEffect(() => {
  const videoSuccess = uploadVideoMicroscopyResponse.status === 'SUCCESS';
  const imageSuccess = uploadImageMicroscopyResponse.status === 'SUCCESS';

  if ((videoSuccess || imageSuccess) && uploadProgress >= 100) {
    const formData = new FormData();
    formData.append('uhid', uhid);

    dispatch(getPatientMicroscopyData(formData))
      .unwrap()
      .then(response => {
        setPatientMicroscopyDetailResponse(response);
      })
      .catch(err => {
        console.error('API Error:', err);
        uiNotificationService.show({
          title: 'Error',
          message: 'Failed to fetch patient microscopy data.',
          type: 'error',
          duration: 3000,
        });
      });

    dispatch(fetchPathologistUser())
      .unwrap()
      .then(response => {
        setPathologistsData(response?.result);
      })
      .catch(err => {
        console.error('API Error:', err);
        uiNotificationService.show({
          title: 'Error',
          message: 'Failed to fetch pathologist users.',
          type: 'error',
          duration: 3000,
        });
      });
  }
}, [
  uploadVideoMicroscopyResponse.status,
  uploadImageMicroscopyResponse.status,
  uploadProgress
]);


  useEffect(() => {
    if (assignedToSuperAdminResponse?.msg?.status === 'SUCCESS') {
      const formData = new FormData();
      formData.append('uhid', uhid);
      dispatch(getPatientMicroscopyData(formData)).unwrap()
        .then(response => {
          setSuccessMsg("Sent to Superadmin successfully.");
          setModal(true);
          setPatientMicroscopyDetailResponse(response);

        })
        .catch(err => {
          console.error('API Error:', err);
        });
      dispatch(clearAssignState())
    }
    if (assignedToSuperAdminResponse?.msg?.status === 'ERROR') {
      uiNotificationService.show({
        title: 'Error',
        message: assignedToSuperAdminResponse?.msg?.msg || 'Something went wrong while sending to Superadmin.',
        type: 'error',
        duration: 3000,
      });
      dispatch(clearAssignState())
    }
  }, [assignedToSuperAdminResponse.status])

  useEffect(() => {
    if (addResearchResponse.status === 'SUCCESS' || addResearchResponse?.status === "failure") {
      setModal(true);
      setSuccessMsg("Study Research added successfully.")
    } else if (addResearchResponse.status == 'ERROR') {
      uiNotificationService.show({
        title: 'Error',
        message: addResearchResponse.msg,
        type: 'error',
        duration: 3000,
      });
    }
    dispatch(closeModal());
  }, [addResearchResponse.status])

  useEffect(() => {
    //Close the dropdown of View More when user click on Esc button and outside dropdown
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.some(ref => ref && ref.contains(event.target))) {
        setShowActionDropdown({}); // Close all dropdowns
      }
    }
    function handleEscKey(event: KeyboardEvent) {
      if (event.key === "Escape") {
        setShowActionDropdown({});
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscKey);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscKey);

    };
  }, []);

  const convertToYYYYMMDD = (isoDate) => {
    const date = new Date(isoDate);

    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}${month}${day}`;
  };

  const handleAddtoResearch = async (item) => {
    setLoader(true);
    const payload = {
      patientId: patientDetails?.result?.patientDetails?.patientId,
      uhid: patientDetails?.result?.patientDetails?.UHID,
      patientName: `${patientDetails?.result.patientDetails.firstName} ${patientDetails?.result.patientDetails.lastName}`,
      dob: patientDetails?.result.patientDetails.dob,
      gender: patientDetails?.result.patientDetails.gender,
      modality: "SM",
      studyRegion: patientDetails?.result?.patientDetails?.healthCareInfo?.sampleLocation || '--',
      referringPhysician: "",
      studyDate: convertToYYYYMMDD(item?.uploadTime),
      wsiId: item?.id
    }
    try {
      await dispatch(addStudyResearch({ studyArray: [payload] }));
      setLoader(false);
    } catch (err) {
      console.error(err);
    }
  }

  const handleSendToSuperadmin = async () => {
    setIsPageLoading(true);

    const payload = {
      patientId: patientDetails?.result.patientDetails._id || "",
      wsiId: selectedWSI?.id || "",
    };

    try {
      await dispatch(assignToSuperadmin(payload)).unwrap();

    } catch (error) {
      console.error("Error sending to superadmin:", error);
      uiNotificationService.show({
        title: 'Error',
        message: error?.message || "Failed to send to Telepathologist.",
        type: 'error',
        duration: 3000,
      });
    } finally {
      setIsPageLoading(false);
    }
  };

  const handleCancelSend = async () => {
    setIsPageLoading(true);

    const obj = {
      wsiID: selectedWSI?.id
    };

    try {
      // Step 1: Check if a report exists
      const currentReportResponse = await getCurrentReport(obj);

      if (currentReportResponse?.result?._id) {
        // If a report exists, show an error popup and stop further execution
        uiNotificationService.show({
          title: 'Error',
          message: 'A report with this WSID already exists. Cannot cancel.',
          type: 'error',
          duration: 3000,
        });
        setIsPageLoading(false);
        return;
      }

      // Step 2: Proceed with cancel action if no report exists
      const payload = {
        patientId: patientDetails?.result.patientDetails._id,
        wsiId: selectedWSI?.id,
        action: "cancel"
      };

      await dispatch(assignToSuperadmin(payload)).unwrap();
      setSuccessMsg("Unsent to Superadmin successfully.");
      setModal(true);
    } catch (error) {
      console.error("Error unsending to superadmin:", error);
      uiNotificationService.show({
        title: 'Error',
        message: error?.message || "Failed to unsend to Telepathologist.",
        type: 'error',
        duration: 3000,
      });
    } finally {
      setIsPageLoading(false);
    }
  };

  const handleUnAssignPathology = async () => {
    setIsPageLoading(true);

    if (!selectedWSI?.id || !selectedWSI?.assignedToPathologist) {
      uiNotificationService.show({
        title: 'Error',
        message: 'No pathologist assigned to this WSI or invalid data.',
        type: 'error',
        duration: 3000,
      });
      setIsPageLoading(false);
      return;
    }

    const payload = {
      patientId: patientDetails?.result.patientDetails._id || "",
      wsiId: selectedWSI?.id || "",
      pathologistId: selectedWSI?.assignedToPathologist || "",
      action: "unassign",
    };

    try {
      const response = await dispatch(assignPathologistApi(payload)).unwrap();

      if (response?.status == "SUCCESS") {
        setSuccessMsg("Pathologist unassigned successfully.");
        setModal(true);

        const updatedPatientMicroscopyDetailResponse = patientMicroscopyDetailResponse.result.map(item => {
          if (item.id === selectedWSI.id) {
            return {
              ...item,
              assignedToPathologist: null,
            };
          }
          return item;
        });

        setPatientMicroscopyDetailResponse({
          ...patientMicroscopyDetailResponse,
          result: updatedPatientMicroscopyDetailResponse,
        });
      } else if (response?.status == "ERROR") {
        uiNotificationService.show({
          title: 'Error',
          message: response?.msg || 'Failed to unassign pathologist.',
          type: 'error',
          duration: 3000,
        });
      }
    } catch (error) {
      console.error('Error unassigning pathologist:', error);
      uiNotificationService.show({
        title: 'Error',
        message: error?.msg || 'An error occurred while unassigning the pathologist.',
        type: 'error',
        duration: 3000,
      });
    } finally {
      setIsPageLoading(false);
    }
  };

  const toggleDropdown = (studyId: string) => {
    setShowActionDropdown(prevState => ({
      ...prevState,
      [studyId]: !prevState[studyId] // Toggle only the clicked study
    }));
  };

  const handleStudySelect = (event, item) => {
    event.stopPropagation();
    const isChecked = event.target.checked;
    setSelectedStudies((curr) => {
      if (isChecked) {
        if (!curr.some((study) => study.id === item.id)) {
          return [...curr, item];
        }
        return curr;
      } else {
        return curr.filter((study) => study.id !== item.id);
      }
    });
  };

  const handleSelectAllClick = (event) => {
    const isChecked = event.target.checked;
    setIsSelectAll(isChecked);
    if (isChecked) {
      const uniqueStudies = Array.from(
        new Map(patientMicroscopyDetailResponse.result.map((study) => [study.id, study])).values()
      );
      setSelectedStudies(uniqueStudies);
    } else {
      setSelectedStudies([]);
    }
  };

  const handleMoveToExtraStorage = async () => {
    if (selectedStudies.length === 0) {
      uiNotificationService.show({
        title: "Warning",
        message: 'Please select atleast one study',
        type: "error",
        position: "topRight"
      })
      return;
    }
    // const studyUids = selectedStudies.map(item => item.studyInstanceUid);
    const payload = {
      "hospitalId": hospitalDetails?._id || "",
      "patientId": ImportScanProps?.patientId || "",
      "microscopyLink": selectedStudies
    }
    setIsPageLoading(true);
    dispatch(switchPathologyStudyStorage(payload)).then((res) => {
      // @ts-ignore
      if (res.payload.status == 'SUCCESS') {
        setIsPageLoading(false);
        uiNotificationService.show({
          title: "Success",
          message: 'Storage switched successfully. Please reload the page after a few moments to see the updated changes.',
          type: "success",
          position: "topRight"
        })
         setTimeout(() => {
            window.location.reload();
          }, 2000);
      }
      if (res.payload.status == 'ERROR') {
        setIsPageLoading(false);
        uiNotificationService.show({
          title: "Failure",
          message: res.payload.msg || 'Something went wrong. Try again later',
          type: "error",
          position: "topRight"
        });
      }
    }).catch((err) => {
      setIsPageLoading(false);
      uiNotificationService.show({
        title: "Failure",
        message: 'Something went wrong. Try again later',
        type: "error",
        position: "topRight"
      })

    }).finally(() => {
      setTimeout(() => {
        setIsPageLoading(false);
      }, 4000);
    });
    const formData = new FormData();
    formData.append('uhid', uhid);
    dispatch(getPatientMicroscopyData(formData)).unwrap()
      .then(response => {
        setPatientMicroscopyDetailResponse(response);
      })
  }
  // ✅ Runs ONCE on first render
useEffect(() => {
  const formData = new FormData();
  formData.append('uhid', uhid);

  dispatch(getPatientMicroscopyData(formData))
    .unwrap()
    .then(response => {
      setPatientMicroscopyDetailResponse(response);
    })
    .catch(err => {
      console.error('API Error:', err);
      uiNotificationService.show({
        title: 'Error',
        message: 'Failed to fetch patient microscopy data.',
        type: 'error',
        duration: 3000,
      });
    });

  dispatch(fetchPathologistUser())
    .unwrap()
    .then(response => {
      setPathologistsData(response?.result);
    })
    .catch(err => {
      console.error('API Error:', err);
      uiNotificationService.show({
        title: 'Error',
        message: 'Failed to fetch pathologist users.',
        type: 'error',
        duration: 3000,
      });
    });
}, []);
  useEffect(() => {
    const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
    if (hospitalId) {
      dispatch(hospitalDetailApi({ hospitalId }));
    }
  }, []);
  useEffect(() => {
    if (hospitalDetailsData?.status === 'SUCCESS') {
      const details: any = hospitalDetailsData?.result;
      setHospitalDetails(details);
    }
  }, [hospitalDetailsData]);

  return (
    <>
      <div className='mx-4 mt-8'>
        {patientMicroscopyDetailResponse?.result?.length > 0 && patientMicroscopyDetailResponse?.storage?.subscriptionPlan?.hasOwnProperty('extraStoragePlan') && (
          <div className="flex justify-end mb-4">
            <div className='hover:bg-gray-200 flex gap-2 items-center justify-start cursor-pointer p-2 btn btn__white__on' onClick={handleMoveToExtraStorage}>
              {/* <div className='h-5 w-5'>
                <img src={extraStorageIconSvg} style={
                  isDarkMode ? { filter: 'invert(1)' } : null} className='object-contain h-[100%] w-[100%]' />
              </div> */}
              <p className='text-[14px] font-regular'>Switch storage</p>
            </div>
            <input
              type="checkbox"
              onClick={handleSelectAllClick}
              checked={isSelectAll}
              className='ml-4 cursor-pointer'
            />
          </div>
        )}
        {patientMicroscopyDetailResponse?.result?.length > 0 ? (
          <ul>
            {patientMicroscopyDetailResponse &&
              patientMicroscopyDetailResponse?.result
                .filter((item) => {
                  // Show all items for superadmins and admins
                  if (role === _roleType.hospitalSuperadmin || role === _roleType.admin || role === _roleType.technician) {
                    return true;
                  }
                  // Otherwise, only show items assigned to the current pathologist
                  return item.assignedToPathologist === currentPathologistId;
                })
                .map((item, index) => {
                  const assignedPathologist = pathologiestData.find(
                    (pathologist) => pathologist._id === item.assignedToPathologist
                  );
                  const filename = item?.url ? item?.url[0]?.split('/').pop() : 'Filename.dzi';
                  return (
                    <li
                      key={index}
                      className="microscopic_box flex flex-row justify-between items-center"
                      onClick={() => {
                        if (!item?.withinLimit) {
                          uiNotificationService.show({
                            position: "topRight",
                            type: "error",
                            message: "Your current subscription does not include access to this study. Please upgrade to continue.",
                            title: "Access Restricted",
                          });
                        }
                      }}
                    >
                      <div className="flex flex-row">
                        <ul>
                          <Icon name="file-icon" />
                        </ul>
                        <ul className="ml-2">{filename}</ul>
                      </div>
                      <div className='flex gap-4 flex-wrap'>
                        {
                          assignedPathologist && <button className='btn rounded border border-black flex' title='Assigned To'>
                            {getIcon('UserCheck')}{assignedPathologist?.name}
                          </button>
                        }
                        {
                          !item?.isCancelled && item?.assignedToSuperAdmin &&
                          <button className='btn rounded border border-black flex' title='Sent to telepathologist'>
                            {getIcon('UserCheck')}Telepathologist
                          </button>
                        }
                        <button className='btn btn__white__on' onClick={() => {
                          navigate(`/WSI/${uhid}/${item?.id}
                          `);
                        }}
                          disabled={!item?.withinLimit}
                        >
                          Click here
                        </button>
                        {role !== _roleType.technician && <div className='relative' ref={el => dropdownRef.current[index] = el}>
                          <button className='btn btn__outlined btn--rounded btn_outlined_wide' onClick={(e) => {
                            e.stopPropagation();
                            toggleDropdown(item.id);
                          }}
                            disabled={!item?.withinLimit}
                          >View More</button>
                          {showActionDropdown[item.id] && (
                            <ul style={{ width: "14rem" }} className={`z-10 right-0 absolute bg-white shadow-md border border-gray-200  `}>
                              {(role == _roleType.admin || role == _roleType.hospitalSuperadmin) && (assignedPathologist &&
                                <li className={`px-4 py-2 hover:bg-gray-200  cursor-pointer text-md font-normal ${isDarkMode ? 'hover:text-black' : ''}`}
                                  onClick={() => {
                                    setSelectedWSI(item)
                                    setConfirmationModal({
                                      title: "Unassign Pathologist",
                                      message: "Are you sure you want to unassign this pathologist?",
                                      type: "UnassignPathologist",
                                      isOpen: true,
                                    });
                                  }}>Unassign</li>)
                              }
                              {role != _roleType.technician &&
                                <li className={`px-4 py-2 hover:bg-gray-200 cursor-pointer text-md font-normal ${isDarkMode ? 'hover:text-black' : ''}`}
                                  onClick={() => {
                                    setSelectedWSI(item);
                                    setConfirmationModal({
                                      title: "Add to Research",
                                      message: "Are you sure want to add this study to Research ?",
                                      type: "Research",
                                      isOpen: true
                                    })
                                  }}>Research</li>
                              }
                              {(role === _roleType.hospitalSuperadmin || role === _roleType.admin) && !assignedPathologist && serviceTelepathology && (
                                <>
                                  {(item?.isCancelled || item?.isCancelled == undefined) ? (
                                    <li className={`px-4 py-2 hover:bg-gray-200 cursor-pointer text-md font-normal ${isDarkMode ? 'hover:text-black' : ''}`} title='Send to telepathology' onClick={() => {
                                      setSelectedWSI(item);
                                      setConfirmationModal({
                                        title: "Send to Telepathologist",
                                        message: "Are you sure you want to send this study to Telepathologist?",
                                        type: "SendSuperadmin",
                                        isOpen: true
                                      });
                                    }}>
                                      Send to Telepathologist
                                    </li>
                                  ) : (
                                    <li className={`px-4 py-2 hover:bg-gray-200 cursor-pointer text-md font-normal ${isDarkMode ? 'hover:text-black' : ''}`} onClick={() => {
                                      setSelectedWSI(item);
                                      setConfirmationModal({
                                        title: "Unassign",
                                        message: "Are you sure you want to unsent from Superadmin?",
                                        type: "CancelSend",
                                        isOpen: true
                                      });
                                    }}>
                                      Unassign
                                    </li>
                                  )}
                                </>
                              )}
                              {/* {(role === 'hospitalsuperadmin' || role === 'Admin') && (item?.isCancelled || item?.isCancelled == undefined) && (!assignedPathologist) && (
                                <>
                                  <li
                                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer text-md font-normal"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (!assignedPathologist) {
                                        handlePathologist(e, item.id);
                                      }
                                    }}
                                  >
                                    <h2 className="button-text">Assign Pathologist</h2>
                                  </li>
                                </>
                              )} */}
                            </ul>
                          )}
                        </div>}
                        {item?.inExtraStorage ?
                          <Tooltip
                            content={`Extra Storage`}
                          >
                            <Icon
                              className="h-[38px] w-[38px]"
                              name={'extraStorageIcon'}
                            />
                          </Tooltip> : <div className='flex items-center justify-center ml-4'> --
                          </div>
                        }
                        {
                          patientMicroscopyDetailResponse?.storage?.subscriptionPlan?.hasOwnProperty('extraStoragePlan') &&
                          <input
                            type="checkbox"
                            className="ml-2 cursor-pointer"
                            checked={selectedStudies.some((study) => study.id === item.id)}
                            onChange={(e) => {
                              handleStudySelect(e, item)
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          />
                        }
                      </div>
                    </li>
                  );
                })}
          </ul>
        ) : (
          <div>
            <p>No result found..</p>
          </div>
        )}

        <AssignPathologistModal
          isOpen={isModaPathologist}
          onClose={() => setIsModalPathologist(false)}
          message={''}
          isError={false}
          patientId={ImportScanProps.patientId}
          wsiId={selectedWSI}
          onAssignSuccess={handleAssignSuccess}
          modality={"SM"}
        />
        {
          prescriptionListData?.map((item, index) => (
            <div key={index} className='rounded-lg'>
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full accordion text-left px-4 py-2 bg-gray-100 rounded-t-lg hover:bg-gray-200"
              >
                <span className='accordion-date'>{formatDate(item?.createdAt, true)}</span>

                <span className='flex items-center gap-4'>
                  <img src={ICONS.delete} alt="Delete"
                  ></img>
                  <img src={ICONS.downarrow} alt="down arrow" />
                </span>
              </button>
              {
                openIndex === index && (
                  <div className="p-4 bg-white border-t accordion-image">
                    <img src={item.documentData}></img>
                  </div>
                )
              }
            </div>
          ))
        }
        {
          role == _roleType.technician &&
          <div className='mt-8'>
            <span className="upload-prescription-text">Import Scan<span className="required-asterisk">*</span></span>
            <div className="uploadDiv">

              <div className='cursor-pointer relative'>
                <SignatureDropzone onDrop={(acceptedFiles) => onDrop(acceptedFiles)}
                  preview={preview}
                />
              </div>
            </div>
            {loader && (
              <div className="progress-container mt-4">
                <div className="progress-bar-background" style={{ width: '100%', height: '10px', backgroundColor: '#e0e0e0' }}>
                  <div
                    className="progress-bar"
                    style={{
                      width: `${uploadProgress}%`,
                      height: '100%',
                      backgroundColor: '#76c7c0',
                      transition: 'width 0.5s ease-in-out',
                    }}
                  ></div>
                </div>
                <p className="text-center mt-2">{uploadProgress}%</p>
              </div>
            )}
            <button
              className='btn btn__primary mt-4'

              onClick={handleUploadImage}
            >
              Upload
            </button>
          </div>
        }

      </div>
      <SuccessModal
        isSuccessModalOpen={modal}
        title={successMsg}
        handleCloseModal={() => setModal(false)}
      />
      <SuccessModal
        isSuccessModalOpen={isSuccessModalOpen}
        title={SuccessMessage}
        handleCloseModal={() => setIsSuccessModal(false)}
      />
      <ConfirmationPopup
        isOpen={confirmationModal?.isOpen}
        title={confirmationModal?.title || "Confirmation"}
        message={confirmationModal?.message || "Are you sure ?"}
        onConfirm={() => {
          if (confirmationModal?.type === "Research") {
            handleAddtoResearch(selectedWSI);
          } else if (confirmationModal?.type === "SendSuperadmin") {
            handleSendToSuperadmin();
          } else if (confirmationModal?.type === "CancelSend") {
            handleCancelSend();
          } else if (confirmationModal?.type === "UnassignPathologist") {
            handleUnAssignPathology();
          }
          setConfirmationModal(prev => ({ ...prev, isOpen: false }));
        }}
        onCancel={() => setConfirmationModal(prev => ({ ...prev, isOpen: false }))}
      />
      <Loader isLoaderOpen={isPageLoading} />
    </>
  )
}

export const SignatureDropzone = ({ onDrop, preview }) => {
  const [error, setError] = useState(null);
const { isDarkMode } = useTheme();
  const handleDrop = (acceptedFiles) => {
    const maxSize = 1024 * 1024 * 1024; // 1 GB
    const validFiles = [];

    setError(null);

    for (const file of acceptedFiles) {
      if (file.size <= maxSize) {
        validFiles.push(file);
      } else {
        // Remove previous image and show error
        onDrop([]); // Clear previous images
        setError(`File ${file.name} is too large. Maximum image size is 1 GB.`);
        break; // Exit loop after showing error
      }
    }

    if (validFiles?.length > 0) {
      onDrop(validFiles); // Send valid files to the parent
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleDrop,
    accept: {
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
      'application/vnd.svs': ['.svs'],
      'video/mp4': ['.mp4'],
    },
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: '2px dashed #cccccc',
        padding: '20px',
        textAlign: 'center',
        marginBottom: '10px',
        width: '100%',
        height: '150px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: isDragActive ? '#f0f0f0' : 'white',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <input {...getInputProps()} />
      <div className='text-center flex flex-col items-center justify-center'>
        {!preview ? (
          <>
            <Icon name="Upload_Icon" alt="appointmentPreview" />
            <p style={{ color: '#000000' }}>Drag & Drop files or <span className='main-theme-color underline' style={{ textDecoration: 'underline' }}>Browse</span></p>
            <p style={{ color: '#000000' }}>Supported format: <span className='main-theme-color'>JPEG, PNG , MP4</span></p>
          </>
        ) : (
          <div>
            {preview.startsWith('data:video') ? (
              <video
                controls
                src={preview}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
              />
            ) : (
              <img
                src={preview}
                alt="Preview"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
              />
            )}
          </div>

        )}
        {error && <p className="text-red-500">{error}</p>}
      </div>
    </div>
  );
};

export default ImportScan
